import {createConfirmation} from 'react-confirm';
import RangePopup from './RangePopup';

export default (confirmation, options = {}) => createConfirmation(RangePopup)({confirmation, options});
